/*
 * @Author: your name
 * @Date: 2021-08-06 14:14:22
 * @LastEditTime: 2021-08-15 18:23:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-bi-project-wrap-h5/src/api/apiList/admini.js
 */
import { requestData } from '../request';
import { java_url } from '../url.js';
import {
    getCookie,
} from "@/utils/utils";
// 登录
export async function login(params) {
    const res = await requestData({
        url: '/user/login',
        queryParams: params,
        method: 'get'
    });
    return res;
}

// // 登出
// export async function logout() {
//     const res = await requestData({
//         url: `/logout?service=${java_url}`,
//         method: 'post',
//         back_url: `//login.zhizh.com`
//     });
//     return res;
// }
export async function logout() {
    const res = await requestData({
        url: `/logout?service=${java_url}`,
        method: 'post',
        back_url: `//${window.location.host}/#/loginInne`
    });
    return res;
}
export async function getMerchantList() {
    const res = await requestData({
        method: "post",
        url:"/api/v1/user/permission/authorized/merchant/list",
        back_url: java_url,
        options: {
            headers: {
                authorization: getCookie("token"),
                'system-id': 3
            }
        } 
    },);
    return res;
}
